import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=b2c418ce&scoped=true&"
import script from "./Statements.vue?vue&type=script&lang=js&"
export * from "./Statements.vue?vue&type=script&lang=js&"
import style0 from "./Statements.vue?vue&type=style&index=0&id=b2c418ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c418ce",
  null
  
)

export default component.exports